__turbopack_context__.v({
  "island": "pAXF1q_island",
});
